import React, { useState, useEffect, useContext } from 'react';
import {
  Typography,
  Input,
  InputNumber,
  Modal,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  Checkbox,
  Tag,
  Icon,
  message,
  Tabs,
  Table,
  Popover
} from 'antd';
import { Link } from "react-router-dom";
import moment from 'moment'
import './index.less';
import { ContextAPI } from '../../../../../ContextAPI';
import { platformApi } from '../../../../../api';

const { Title } = Typography;
const { Item } = Form;
const { TabPane } = Tabs;
const SparesModal = (props) => {
  const { form, open, close, data, editable, branch, getPSI, modify } = props
  const { getFieldDecorator, getFieldValue } = form;
  const [dataSource, setData] = useState(null);
  const [HistoryData, setHistoryData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [masterBinLocations, setMasterBinLocations] = useState([]);
  const user = useContext(ContextAPI);

  const getBranchMasterBins = (masterBins, branchObj) => {
    if (!masterBins || masterBins.length === 0 || !branchObj) return [];
    const targetId = branchObj.id ? String(branchObj.id) : (typeof branchObj === 'string' ? branchObj : null);
    const targetName = branchObj.name ? String(branchObj.name).trim().toLowerCase() : (typeof branchObj === 'string' ? branchObj.trim().toLowerCase() : null);

    const filtered = masterBins.filter(b => {
      const bBranch = b.Branch || b.branch;
      const bBranchId = bBranch?.id || b.branchId || (typeof b.branch === 'string' ? b.branch : null);
      const bBranchName = bBranch?.name || (typeof b.branch === 'object' ? b.branch?.name : null);

      if (targetId && bBranchId && String(bBranchId) === targetId) {
        return true;
      }
      if (targetName && bBranchName && String(bBranchName).trim().toLowerCase() === targetName) {
        return true;
      }
      return false;
    });

    // Sort ascending by creation time so the 1st created bin location comes first
    return filtered.sort((a, b) => {
      const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return timeA - timeB;
    });
  };

  useEffect(() => {
    if (open) {
      platformApi.post("/api/binLocation/get", { page: 1, size: 500, searchString: "" })
        .then((res) => {
          if (res?.data?.code === 200) {
            setMasterBinLocations(res.data.response?.data?.binLocation || []);
          }
        })
        .catch((err) => console.error("Error fetching bin location master: ", err));
    }
  }, [open]);

  useEffect(() => {
    if (dataSource && dataSource.length > 0 && masterBinLocations.length > 0) {
      let changed = false;
      const updated = dataSource.map(item => {
        const branchMasterBins = getBranchMasterBins(masterBinLocations, item.branch);
        if (branchMasterBins.length === 0) return item;

        let mainBin = item.binNum;
        let itemChanged = false;

        if (!mainBin && branchMasterBins.length > 0) {
          mainBin = branchMasterBins[0].binLocation;
          itemChanged = true;
        }

        let extraLocs = item.extraLocations ? [...item.extraLocations] : [];
        branchMasterBins.forEach(b => {
          const exists = extraLocs.some(e => (e.binNum || e.binLocation || '').trim().toLowerCase() === b.binLocation.trim().toLowerCase());
          if (!exists) {
            extraLocs.push({
              phyQuantity: 0,
              accQuantity: 0,
              allocatedQuantity: 0,
              binNum: b.binLocation
            });
            itemChanged = true;
          }
        });

        if (itemChanged) {
          changed = true;
          return {
            ...item,
            binNum: mainBin,
            extraLocations: extraLocs
          };
        }
        return item;
      });

      if (changed) {
        setData(updated);
      }
    }
  }, [masterBinLocations, open]);

  useEffect(() => {
    if (data) {
      console.log("recieved", data)
      form.setFieldsValue({
        partName: data.partNo.partName,
        partNumber: data.partNo.partNumber,
      });

      platformApi.post("/api/sparesInventory/getPart", {
        partNo: data.partNo.id,
        skipNull: false   // get ALL branches, even those with phyQty=0
      }).then(allBranchesRes => {
        const allBranchRecords = allBranchesRes?.data?.response?.data?.sparesInventory || [];

        platformApi.get("/api/sparesInventory/branch/all").then((res) => {
          const { data: resData } = res;
          if (resData.code === 200) {
            const branchesList = resData.response.data || [];

            const mergedData = branchesList.map(branch => {
              const fromAllBranches = allBranchRecords.find(r => r.branch?.id === branch.id);
              const branchMasterBins = getBranchMasterBins(masterBinLocations, branch);

              let parsedLocs = [];
              if (fromAllBranches?.binLocations) {
                try {
                  parsedLocs = typeof fromAllBranches.binLocations === 'string'
                    ? JSON.parse(fromAllBranches.binLocations)
                    : fromAllBranches.binLocations;
                } catch (e) {
                  parsedLocs = [];
                }
              }

              const loc1 = {
                phyQuantity: fromAllBranches?.phyQuantity || 0,
                accQuantity: fromAllBranches?.accQuantity || 0,
                allocatedQuantity: fromAllBranches?.allocatedQuantity || 0,
                binNum: fromAllBranches?.binNum || (branchMasterBins[0]?.binLocation || "")
              };

              let allLocs = parsedLocs.length > 0 ? [...parsedLocs] : [loc1];

              // Filter out ALL locations (both temp/custom and permanent master) with phyQuantity <= 0
              const masterLocNames = branchMasterBins.map(b => (b.binLocation || '').trim().toLowerCase());
              allLocs = allLocs.filter(loc => {
                const qty = parseInt(loc.phyQuantity || 0);
                return qty > 0;
              });

              // Separate Temp/Custom locations and Permanent Master locations
              // Display Temp/Custom locations FIRST, Permanent Master locations SECOND
              const tempLocs = [];
              const permanentLocs = [];

              allLocs.forEach(loc => {
                const locName = (loc.binNum || loc.binLocation || '').trim().toLowerCase();
                if (masterLocNames.includes(locName)) {
                  permanentLocs.push(loc);
                } else {
                  tempLocs.push(loc);
                }
              });

              const extraLocs = [...tempLocs, ...permanentLocs];
              const mainBinVal = extraLocs[0]?.binNum || (loc1.binNum || (branchMasterBins[0]?.binLocation || ""));

              if (fromAllBranches) {
                return {
                  ...fromAllBranches,
                  key: fromAllBranches.id,
                  sparesId: fromAllBranches.id,
                  branch: branch,
                  phyQuantity: loc1.phyQuantity,
                  accQuantity: loc1.accQuantity,
                  allocatedQuantity: loc1.allocatedQuantity,
                  binNum: mainBinVal,
                  extraLocations: extraLocs
                };
              }
              return {
                key: "temp_" + branch.id,
                sparesId: "temp_" + branch.id,
                branch: branch,
                phyQuantity: 0,
                accQuantity: 0,
                allocatedQuantity: 0,
                binNum: mainBinVal,
                minStock: 0,
                maxStock: 0,
                reorderLevel: 0,
                reorderQuantity: 0,
                extraLocations: extraLocs
              };
            });
            setData(mergedData);
          } else {
            message.error(resData.message)
          }
        })
      })

      platformApi.get(`/api/sparesInventory/getSparesHistory/${data.partNo.id}?t=${Date.now()}`)
        .then((result) => {
          let { data: resData } = result;
          if (resData.code === 200) {
            let { response } = resData;
            if (response.code === 200) {
              let historyData = []
              if (response.data && response.data.length > 0) {
                for (let i = 0; i < response.data.length; i++) {
                  let hisObj = response.data[i];
                  hisObj["linkObj"] = {}
                  if (hisObj.sparesMaterialSale) {
                    let pathId = hisObj.sparesMaterialSale.id
                    hisObj["linkObj"]["link"] = `/autoadmin/material_issue/${pathId}`
                    hisObj["linkObj"]["id"] = hisObj.sparesMaterialSale.job?.jobNo
                  } else if (hisObj.sparesSale) {
                    if (hisObj.sparesSale.jobOrder) {
                      let pathId = hisObj.sparesSale.id
                      hisObj["linkObj"]["link"] = `/autoadmin/job_invoice/${pathId}`
                      hisObj["linkObj"]["id"] = hisObj.sparesSale.invoiceNumber
                    }
                    else {
                      let pathId = hisObj.sparesSale.id
                      hisObj["linkObj"]["link"] = `/autoadmin/counter_sale/${pathId}`
                      hisObj["linkObj"]["id"] = hisObj.sparesSale.invoiceNumber
                    }
                  }
                  else if (hisObj.sparesPurchase) {
                    let pathId = hisObj.sparesPurchase.id
                    hisObj["linkObj"]["link"] = `/autoadmin/purchase_spares_invoice/${pathId}`
                    hisObj["linkObj"]["id"] = hisObj.sparesPurchase.invoiceNumber
                  }
                  else if (hisObj.type && hisObj.type.includes("Transfer")) {
                    hisObj["linkObj"]["link"] = `/autoadmin/transfer/spares`
                    hisObj["linkObj"]["id"] = "Transfer"
                  }
                  else if (hisObj.type && (hisObj.type.includes("Stock Inward") || hisObj.type.includes("Stock Check"))) {
                    hisObj["linkObj"]["link"] = ""
                    hisObj["linkObj"]["id"] = hisObj.inwardNo || "Stock Inward"
                    hisObj["linkObj"]["id"] = "Stock Inward"
                  }
                  historyData.push(hisObj)
                }
              }
              setHistoryData(historyData)
            }
          }
        })
        .catch((err) => {
          console.error("Couldn't get Part History: ", err);
          message.error("Couldn't get Part History");
        });
    }
  }, [data, open, masterBinLocations]);

  const toggleRowExpand = (record) => {
    const rowKey = record.sparesId || record.key;
    if (expandedRowKeys.includes(rowKey)) {
      setExpandedRowKeys(expandedRowKeys.filter(k => k !== rowKey));
    } else {
      setExpandedRowKeys([...expandedRowKeys, rowKey]);
    }
  };

  const editExtraStock = (sparesId, subIdx, field, value) => {
    if (!dataSource) return;
    const updatedData = dataSource.map(item => {
      if (item.sparesId === sparesId || item.key === sparesId) {
        const extraCopy = [...(item.extraLocations || [])];
        let val = value;
        if (field !== "binNum" && typeof value === 'number') {
          val = value < 0 ? 0 : value;
        }
        extraCopy[subIdx] = {
          ...extraCopy[subIdx],
          [field]: val
        };

        let updatedItem = { ...item, extraLocations: extraCopy };
        if (subIdx === 0) {
          updatedItem[field] = val;
        }
        return updatedItem;
      }
      return item;
    });
    setData(updatedData);
  };

  const addExtraLocation = (sparesId) => {
    if (!dataSource) return;
    const updatedData = dataSource.map(item => {
      if (item.sparesId === sparesId || item.key === sparesId) {
        const extraCopy = [...(item.extraLocations || [])];
        extraCopy.push({ phyQuantity: 0, accQuantity: 0, allocatedQuantity: 0, binNum: "" });
        return { ...item, extraLocations: extraCopy };
      }
      return item;
    });
    setData(updatedData);
  };

  const removeExtraLocation = (sparesId, subIdx) => {
    if (!dataSource) return;
    const updatedData = dataSource.map(item => {
      if (item.sparesId === sparesId || item.key === sparesId) {
        const extraCopy = (item.extraLocations || []).filter((_, i) => i !== subIdx);
        return { ...item, extraLocations: extraCopy };
      }
      return item;
    });
    setData(updatedData);
  };

  const renderExtendedRows = (record) => {
    const branchMasterBins = getBranchMasterBins(masterBinLocations, record.branch);

    // Auto-populate extended rows for all master bin location records of this branch starting from index 0
    let extraLocs = record.extraLocations || [];
    if (extraLocs.length === 0 && editable) {
      if (branchMasterBins.length > 0) {
        extraLocs = branchMasterBins.map(b => ({
          phyQuantity: 0,
          accQuantity: 0,
          allocatedQuantity: 0,
          binNum: b.binLocation
        }));
      } else {
        extraLocs = [{ phyQuantity: 0, accQuantity: 0, allocatedQuantity: 0, binNum: "" }];
      }
    }

    const isScrollable = extraLocs.length > 4;

    return (
      <div
        style={{
          backgroundColor: "#f0f2f5",
          paddingLeft: "5px",
          maxHeight: isScrollable ? "250px" : "none",
          overflowY: isScrollable ? "auto" : "visible"
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse", margin: 0 }}>
          <colgroup>
            <col style={{ width: 120 }} />
            <col style={{ width: 140 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 65 }} />
            <col style={{ width: 65 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 75 }} />
            <col style={{ width: 60 }} />
          </colgroup>
          <tbody>
            {extraLocs.map((subItem, subIdx) => {
              const subBinVal = subItem.binNum || (branchMasterBins[subIdx] ? branchMasterBins[subIdx].binLocation : undefined);
              return (
                <tr key={subIdx}>
                  {/* Col 1: Empty space (matches Branch Name column width) */}
                  <td style={{ padding: "16px 8px" }} />

                  {/* Col 2: Bin Location */}
                  <td style={{ padding: "16px 8px", verticalAlign: "middle" }}>
                    <Input
                      style={{ width: "calc(100% - 10px)" }}
                      placeholder="Bin Location"
                      value={subBinVal || ""}
                      disabled={!modify}
                      onChange={(e) => editExtraStock(record.sparesId, subIdx, "binNum", e.target.value)}
                    />
                  </td>

                  {/* Col 3: Physical Qty */}
                  <td style={{ padding: "16px 8px", verticalAlign: "middle" }}>
                    <InputNumber
                      style={{ width: "calc(100% - 14px)", marginLeft: "10px" }}
                      min={0}
                      placeholder="0"
                      value={subItem.phyQuantity}
                      disabled={!modify}
                      onChange={(val) => editExtraStock(record.sparesId, subIdx, "phyQuantity", val)}
                    />
                  </td>

                  {/* Col 4: Accounting Qty (Commented out) */}
                  <td style={{ padding: "16px 8px", verticalAlign: "middle" }}>
                    {/* <InputNumber
                      style={{ width: "calc(100% - 14px)" }}
                      min={0}
                      placeholder="0"
                      value={subItem.accQuantity}
                      disabled={!modify}
                      onChange={(val) => editExtraStock(record.sparesId, subIdx, "accQuantity", val)}
                    /> */}
                  </td>

                  {/* Col 5: Allocated Qty (Commented out) */}
                  <td style={{ padding: "16px 8px", verticalAlign: "middle" }}>
                    {/* <InputNumber
                      style={{ width: "calc(100% - 14px)" }}
                      min={0}
                      placeholder="0"
                      value={subItem.allocatedQuantity}
                      disabled={!modify}
                      onChange={(val) => editExtraStock(record.sparesId, subIdx, "allocatedQuantity", val)}
                    /> */}
                  </td>

                  {/* Cols 6-10: Empty cells */}
                  <td style={{ padding: "16px 8px" }} />
                  <td style={{ padding: "16px 8px" }} />
                  <td style={{ padding: "16px 8px" }} />
                  <td style={{ padding: "16px 8px" }} />
                  <td style={{ padding: "16px 8px" }} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branch",
      key: "branch",
      width: 120,
      render: (record) => { return <span>{record && record.name}</span> },
    },
    {
      title: "Bin Location",
      width: 140,
      render: (record) => {
        return (
          <Input
            style={{ width: "100%" }}
            placeholder=""
            disabled={true}
            value=""
          />
        );
      },
    },
    {
      title: "Physical Qty",
      width: 75,
      render: (record) => {
        const totalPhy = (record.extraLocations && record.extraLocations.length > 0)
          ? record.extraLocations.reduce((sum, loc) => sum + (parseInt(loc.phyQuantity) || 0), 0)
          : (record.phyQuantity || 0);

        return (user && user.loginCredintials && user.loginCredintials.role == "CEO" ?
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            placeholder="Physical Quantity"
            onChange={(val) => { editStocks(record.sparesId, "phyQuantity", val) }}
            value={totalPhy}
            disabled={!modify}
          />
          : <span>{totalPhy}</span>);
      },
    },
    {
      title: "Accounting Qty",
      width: 75,
      render: (record, data) => {
        return (user && user.loginCredintials && user.loginCredintials.role == "CEO" ?
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Accounting Quantity" onChange={(val) => { editStocks(record.sparesId, "accQuantity", val) }} value={record.accQuantity} disabled={!modify} />
          : <span>{record.accQuantity ? record.accQuantity : 0}</span>)
      },
    },
    {
      title: "Allocated Qty",
      width: 75,
      render: (record, data) => {
        return (user && user.loginCredintials && user.loginCredintials.role == "CEO" ?
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Allocated Quantity" onChange={(val) => { editStocks(record.sparesId, "allocatedQuantity", val) }} value={record.allocatedQuantity} disabled={!modify} />
          : <span>{record.allocatedQuantity ? record.allocatedQuantity : 0}</span>)
      },
    },
    {
      title: "Min Stock",
      width: 65,
      render: (record) => {
        return (
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Min Stock" onChange={(val) => { editStocks(record.sparesId, "minStock", val) }} value={record.minStock} disabled={!modify} />
        )
      },
    },
    {
      title: "Max Stock",
      width: 65,
      render: (record) => {
        return (
          <InputNumber style={{ width: "100%" }} min={0} placeholder="Max Stock" onChange={(val) => { editStocks(record.sparesId, "maxStock", val) }} value={record.maxStock} disabled={!modify} />
        )
      },
    },
    {
      title: "Reorder Level",
      width: 75,
      render: (record) => {
        return (<InputNumber style={{ width: "100%" }} min={0} placeholder="Reorder Level" onChange={(val) => { editStocks(record.sparesId, "reorderLevel", val) }} value={record.reorderLevel} disabled={!modify} />)
      },
    },
    {
      title: "Reorder Qty",
      width: 75,
      dataIndex: "",
      key: "",
      render: (record) => {
        return (
          <InputNumber style={{ width: "100%" }} min={0} placeholder="reorderQuantity" onChange={(val) => { editStocks(record.sparesId, "reorderQuantity", val) }} value={record.reorderQuantity} disabled={!modify} />
        )
      },
    },
    {
      title: "Action",
      key: "action",
      width: 60,
      align: "center",
      render: (text, record) => {
        const rowKey = record.sparesId || record.key;
        const isExpanded = expandedRowKeys.includes(rowKey);
        return (
          <Icon
            type={isExpanded ? "up" : "down"}
            style={{
              color: "#00565b",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              padding: "4px"
            }}
            onClick={() => toggleRowExpand(record)}
          />
        );
      },
    },
  ]

  const editStocks = (id, name, value) => {
    let data = [...dataSource]
    let newValue = value;
    if (name !== "binNum") {
      newValue = value < 0 ? 0 : value;
    }
    for (let item of data) {
      if (item.sparesId == id) {
        item[name] = newValue
        if (item.extraLocations && item.extraLocations.length > 0) {
          const extraCopy = [...item.extraLocations];
          extraCopy[0] = { ...extraCopy[0], [name]: newValue };
          item.extraLocations = extraCopy;
        }
        break
      }
    }
    setData(data)
  }

  const handleSubmit = () => {
    if (!modify) {
      message.error("You do not have permission to modify spares inventory.");
      return;
    }
    const branchPayload = dataSource.map(item => {
      const branchMasterBins = getBranchMasterBins(masterBinLocations, item.branch);

      const extraList = item.extraLocations || [];
      const totalPhyQty = extraList.length > 0
        ? extraList.reduce((sum, l) => sum + (parseInt(l.phyQuantity) || 0), 0)
        : parseInt(item.phyQuantity || 0);

      const firstLoc = extraList[0] || {};
      const loc1Bin = firstLoc.binNum || item.binNum || (branchMasterBins.length > 0 ? branchMasterBins[0].binLocation : "");

      const loc1 = {
        phyQuantity: parseInt(firstLoc.phyQuantity !== undefined ? firstLoc.phyQuantity : (item.phyQuantity || 0)),
        accQuantity: parseInt(firstLoc.accQuantity !== undefined ? firstLoc.accQuantity : (item.accQuantity || 0)),
        allocatedQuantity: parseInt(firstLoc.allocatedQuantity !== undefined ? firstLoc.allocatedQuantity : (item.allocatedQuantity || 0)),
        binNum: loc1Bin
      };

      const validExtras = extraList.slice(1).map((l, idx) => ({
        phyQuantity: parseInt(l.phyQuantity || 0),
        accQuantity: parseInt(l.accQuantity || 0),
        allocatedQuantity: parseInt(l.allocatedQuantity || 0),
        binNum: l.binNum || (branchMasterBins[idx + 1] ? branchMasterBins[idx + 1].binLocation : "")
      })).filter(l => l.binNum || l.phyQuantity > 0);

      const allLocations = [loc1, ...validExtras];

      return {
        branch: item.branch?.id,
        binNum: loc1Bin,
        addressType: allLocations.length > 1 ? "DIFFERENT" : "SAME",
        binLocations: JSON.stringify(allLocations),
        reorderQuantity: parseInt(item.reorderQuantity || 0),
        maxStock: parseInt(item.maxStock || 0),
        minStock: parseInt(item.minStock || 0),
        reorderLevel: parseInt(item.reorderLevel || 0),
        phyQuantity: totalPhyQty,
        accQuantity: parseInt(item.accQuantity || 0),
        allocatedQuantity: parseInt(item.allocatedQuantity || 0)
      };
    });

    platformApi.post("/api/sparesInventory", {
      part: data.partNo,
      branch: branchPayload
    }).then(result => {
      let { data: resData } = result;
      if (resData.code === 200) {
        message.success("Spares Inventory Modified Successfully");
        getPSI();
        close();
        setData(null);
        form.resetFields();
      }
    }).catch((err) => {
      console.error("SparesInventory Add Error: ", err);
      message.error("Couldn't Modify SparesInventory");
    });
  }

  const HistoryColumn = [
    {
      title: "Transcation Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record, data) => (<span>{record && moment(new Date(record)).format("DD-MM-YYYY")}</span>
      )
    },
    /* {
       title: "Part Details",
       dataIndex: "Part",
       key: "Part",
       render: record => <span disabled="true">{
         `${record.partNumber} - ${record.partName}`
       }</span>
     },*/
    {
      title: "Transaction Type",
      dataIndex: "type",
      key: "type",
      render: (record, data) => (<span>{record}</span>)
    },
    {
      title: "Transaction Link",
      dataIndex: "linkObj",
      key: "linkObj",
      render: (record, data) => {
        if (!record || !record.id || record.id === "-") return <span>-</span>;
        if (record.link) {
          return <Link to={record.link} className="linkylink">{record.id}</Link>;
        }
        return <span style={{ fontWeight: 600, color: "#00565b" }}>{record.id}</span>;
      }
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (record) => (<span>{record && record.name ? record.name : "-"}</span>)
    },
    {
      title: "Physical Quantity",
      dataIndex: "phyQty",
      key: "phyQty",
      render: (data, record) => {
        let displayVal = null;
        let color = "";

        if (record?.sparesMaterialSale) {
          // Parts Issue: only phyQty is reduced
          const matchedItem = record.sparesMaterialSale.parts.find(item => item.part.id === record.Part.id);
          if (matchedItem) {
            displayVal = `-${matchedItem.quantity}`;
            color = "red";
          }
        } else if (record?.sparesSale) {
          if (record.sparesSale.jobOrder) {
            // Job Card Invoice: phyQty was ALREADY reduced at Parts Issue time.
            // Only accQty is reduced here — show "–" for Physical Quantity.
            displayVal = "-";
          } else {
            // Counter Sale: reduces both phyQty and accQty simultaneously.
            const matchedItem = record.sparesSale.saleItemInvoice.find(item => item.partNumber && item.partNumber.id === record.Part.id);
            if (matchedItem) {
              displayVal = `-${matchedItem.quantity}`;
              color = "red";
            }
          }
        } else if (record?.sparesPurchase) {
          const matchedItem = record.sparesPurchase.purchaseItemInvoice.find(item => item.partNumber && item.partNumber.id === record.Part.id);
          if (matchedItem) {
            const verifiedCount = matchedItem.tickedCount || (matchedItem.isVerified ? matchedItem.quantity : 0);
            if (verifiedCount > 0) {
              displayVal = `+${verifiedCount}`;
              color = "green";
            } else {
              displayVal = "-";
            }
          }
        } else if (
          record?.type === "Manual Adjustment" ||
          record?.type === "Initial Inventory" ||
          (record?.type && (record.type.includes("Transfer") || record.type.includes("Stock Inward") || record.type.includes("Stock Check")))
        ) {
          const qty = record.Quantity || 0;
          if (qty < 0) {
            displayVal = `${qty}`;
            color = "red";
          } else {
            displayVal = `+${qty}`;
            color = "green";
          }
        }

        return (
          <div style={{ textAlign: "center" }}>
            <span style={{ color: color, fontWeight: "bold" }}>
              {displayVal !== null ? displayVal : "-"}
            </span>
          </div>
        );
      }
    },

    {
      title: "Account Quantity",
      dataIndex: "accQty",
      key: "accQty",
      render: (data, record) => {
        let displayVal = null;
        let color = "";

        if (record?.sparesMaterialSale) {
          displayVal = "-";
        } else if (record?.sparesSale) {
          const matchedItem = record.sparesSale.saleItemInvoice.find(item => item.partNumber && item.partNumber.id === record.Part.id);
          if (matchedItem) {
            displayVal = `-${matchedItem.quantity}`;
            color = "red";
          }
        } else if (record?.sparesPurchase) {
          const matchedItem = record.sparesPurchase.purchaseItemInvoice.find(item => item.partNumber && item.partNumber.id === record.Part.id);
          if (matchedItem) {
            displayVal = `+${matchedItem.quantity}`;
            color = "green";
          }
        } else if (
          record?.type === "Manual Adjustment" ||
          record?.type === "Initial Inventory" ||
          (record?.type && (record.type.includes("Transfer") || record.type.includes("Stock Inward") || record.type.includes("Stock Check")))
        ) {
          const qty = record.accQuantity !== undefined ? record.accQuantity : (record.Quantity || 0);
          if (qty < 0) {
            displayVal = `${qty}`;
            color = "red";
          } else {
            displayVal = `+${qty}`;
            color = "green";
          }
        }

        return (
          <div style={{ textAlign: "center" }}>
            <span style={{ color: color, fontWeight: displayVal === "-" ? "normal" : "bold" }}>
              {displayVal !== null ? displayVal : "-"}
            </span>
          </div>
        );
      }
    },
    // {
    //   title: "JOB Card",
    //   dataIndex: "sparesMaterialSale",
    //   key: "sparesMaterialSale",
    //   render: (record, data) => (<Link to={record?.link} className={record && record.job ? "linkylink" : ""}>{record && record.job ? record.job.jobNo : "-"}</Link>)
    // },
    // {
    //   title: "Sale Invoice",
    //   dataIndex: "sparesSale",
    //   key: "sparesSale",
    //   render: (record, data) => (<Link to={record?.link} className={record && record.invoiceNumber ? "linkylink" : ""}>{record && record.invoiceNumber ? record.invoiceNumber : "-"}</Link>)
    // },
    // {
    //   title: "Purchase Invoice",
    //   dataIndex: "sparesPurchase",
    //   key: "sparesPurchase",
    //   render: (record, data) => (<Link to={record?.link} className={record && record.invoiceNumber ? "linkylink" : ""}>{record && record.invoiceNumber ? record.invoiceNumber : "-"}</Link>)
    // },
    // {
    //   title: "Quantity",
    //   dataIndex: "x",
    //   key: "x",
    //   render: (data, record) => {
    //     return (
    //       <>
    //         {
    //           record?.sparesMaterialSale &&
    //           record?.sparesMaterialSale && record?.sparesMaterialSale?.parts.map(item => {
    //             if (record.status === "True") {
    //               if (item.part.id === record.Part.id) {
    //                 return (
    //                   // changes Done
    //                   <span>
    //                     {item.quantity + record.Quantity}
    //                   </span>
    //                 )
    //               }
    //             }
    //             else {
    //               if (item.part.id === record.Part.id) {
    //                 return (
    //                   <span style={{ backgroundColor: "red", padding: '5px' }}>
    //                     {item.quantity}
    //                   </span>
    //                 )
    //               }
    //             }

    //           })
    //         }
    //         {
    //           record?.sparesSale &&
    //           record?.sparesSale && record?.sparesSale?.saleItemInvoice.map(item => {
    //             if (item.partNumber)
    //               if (item.partNumber.id === record.Part.id) {
    //                 return (
    //                   <span>
    //                     {item.quantity}
    //                   </span>
    //                 )
    //               }
    //           })
    //         }
    //         {
    //           record?.sparesPurchase &&
    //           record?.sparesPurchase && record?.sparesPurchase?.purchaseItemInvoice.map(item => {
    //             if (item.partNumber)
    //               if (item.partNumber.id === record.Part.id) {
    //                 return (
    //                   <span>
    //                     {item.quantity}
    //                   </span>
    //                 )
    //               }
    //           })
    //         }
    //       </>
    //     )
    //   }
    // },

  ];

  return (
    <>
      <Modal
        wrapClassName="pmc-form"
        layout="horizontal"
        visible={open}
        title={<Title level={4}>Spares Inventory</Title>}
        onCancel={() => {
          // document.getElementById('resetForm').reset();
          close();
          setData(null)
          form.resetFields()
          getPSI()
        }}
        okButtonProps={!modify ? { style: { display: "none" } } : undefined}
        cancelText={modify ? "Cancel" : "Close"}
        style={{ width: '100%' }}
        onOk={() => (handleSubmit())}
      >
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                Spares Details
              </span>
            }
            key="1"
          >
            <Form>
              <Row>
                <Col span={8}>
                  <Form.Item
                    className="form-element"
                    label="Part No"
                  // name="partNo"
                  >
                    {getFieldDecorator("partNumber", {
                    })(
                      <Input placeholder="Part No" disabled={!editable} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={1} />
                <Col span={12}>
                  <Form.Item
                    className="form-element"
                    label="Part Name"
                    name="partName"
                  >
                    {getFieldDecorator("partName", {
                    })(

                      <Input style={{ width: '180%' }} placeholder="Part Name" disabled={!editable} />
                    )}
                  </Form.Item>
                </Col>

              </Row>
              <div id="resetForm" className="spares-inventory-table-container">
                <style>{`
                  .spares-inventory-table-container .ant-table-expanded-row > td {
                    padding: 0 !important;
                  }
                `}</style>
                <Table
                  style={{ marginTop: '1rem' }}
                  columns={columns}
                  tableLayout="fixed"
                  rowKey={(record) => record.sparesId || record.key}
                  dataSource={dataSource}
                  expandedRowKeys={expandedRowKeys}
                  expandIconAsCell={false}
                  expandIcon={() => null}
                  expandIconColumnIndex={-1}
                  expandedRowRender={(record) => renderExtendedRows(record)}
                />
              </div>

            </Form>
          </TabPane>
          <TabPane tab={<span>Spares History</span>} key="2">
            <Form>
              <Row>
                <Col span={8}>
                  <Form.Item
                    className="form-element"
                    label="Part No"
                  // name="partNo"
                  >
                    {getFieldDecorator("partNumber", {
                    })(
                      <Input placeholder="Part No" disabled={!editable} />
                    )}
                  </Form.Item>
                </Col>
                <Col span={1} />
                <Col span={12}>
                  <Form.Item
                    className="form-element"
                    label="Part Name"
                    name="partName"
                  >
                    {getFieldDecorator("partName", {
                    })(

                      <Input style={{ width: '180%' }} placeholder="Part Name" disabled={!editable} />
                    )}
                  </Form.Item>
                </Col>

              </Row>

            </Form>
            <br />

            <Table
              pagination={{
                pageSize: 5,
                defaultCurrent: 1,
                showQuickJumper: true
              }}
              style={
                {
                  marginBottom: "1rem"
                }
              }
              rowKey={(record) => record.id}

              columns={HistoryColumn}
              dataSource={HistoryData}
            // pagination={false}
            />
          </TabPane>
        </Tabs>

      </Modal>
    </>
  )
}
const WrappedSparesModal = Form.create()(
  SparesModal
);

export default WrappedSparesModal;